import { emptyApi } from "./emptyApi";

export type TermsOfService = {
  uuid: string;
  version: string;
  effective_date: string;
  document_url: string;
  is_accepted: boolean;
};

export type TermsOfServiceAcceptance = {
  uuid: string;
  platform_tos: string;
  accepted_at: string;
};

export const termsOfServiceApis = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getCurrentTermsOfService: build.query<TermsOfService | null, void>({
      query: () => "/api/inkle/users/platform-tos/current/",
      providesTags: ["TERMS_OF_SERVICE"],
    }),

    acceptTermsOfService: build.mutation<
      TermsOfServiceAcceptance,
      { termsOfServiceId: string }
    >({
      query: ({ termsOfServiceId }) => ({
        url: `/api/inkle/users/platform-tos/${termsOfServiceId}/accept/`,
        method: "POST",
      }),
      invalidatesTags: ["TERMS_OF_SERVICE"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCurrentTermsOfServiceQuery,
  useAcceptTermsOfServiceMutation,
} = termsOfServiceApis;
